import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var triangleFilledPath = 'M28.7589 7.62493L45.2634 35.0827C47.3671 38.5821 44.7115 43 40.504 43H7.49598C3.28854 43 0.632882 38.5821 2.7366 35.0827L19.2411 7.62493C21.3443 4.12502 26.6557 4.12502 28.7589 7.62493Z';
var exclamationHeadPath = 'M25.7263 37.1556C25.2496 37.5768 24.6544 37.8184 23.9408 37.8184C23.2855 37.8184 22.6903 37.5768 22.2148 37.1556C21.7387 36.7339 21.5 36.0711 21.5 35.2872C21.5 34.5647 21.7387 34.0225 22.2148 33.5404C22.6903 33.0584 23.2855 32.8174 24.0003 32.8174C24.7145 32.8174 25.3097 33.0584 25.7858 33.5404C26.2613 34.0225 26.5 34.625 26.5 35.2872C26.5 36.0711 26.2613 36.673 25.7263 37.1556';
var exclamationDotPath = 'M26.2401 19.8351L25.6001 27.2051C25.5401 28.1551 25.3551 28.9601 25.1201 29.4351C24.8701 29.9151 24.5626 30.0751 24.0001 30.0751C23.4376 30.0751 23.1051 29.9231 22.8801 29.4351C22.6634 28.9651 22.4451 28.1501 22.3901 27.2051L21.6051 19.8351C21.4588 18.3836 21.2797 16.5527 21.9151 15.2051C22.2852 14.4201 23.0401 14.0701 24.0001 14.0701C24.9601 14.0701 25.8152 14.4101 26.0701 15.2051C26.4837 16.4951 26.4151 18.4001 26.2401 19.8351Z';
var AlertIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: triangleFilledPath
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: exclamationHeadPath,
    svgColor: "white"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: exclamationDotPath,
    svgColor: "white"
  }));
});
AlertIcon.displayName = 'AlertIcon';
AlertIcon.defaultProps = {
  'aria-label': 'Error'
};
export default AlertIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/AlertIcon/index.js
// module id = 1786
// module chunks = 12